import { combineReducers } from 'redux';

import fetchStationDetailsMap, {
    fetchStationDetailsAction,
} from './actions/fetchStationDetails';
import stationsReducerMap, {
    selectors as stationSelectors,
} from './appstate';
import NAMESPACE from './types';

const reducer = combineReducers({
    ...fetchStationDetailsMap,
    ...stationsReducerMap,
});

export {
    fetchStationDetailsAction,
    stationSelectors,
};

export default { [NAMESPACE]: reducer };
